<!-- Content -->
<div id="content" class="mt-3">
  <div class="container">


    <div class="white-box enquiry-success">
      <div class="enquiry-icon">
        <span class="ak-holidays holiday-icon"></span>
        <span class="ak-checked status-icon"></span>
      </div>
      <h3 class="success-header">Request Submitted!</h3>
      <div class="request-id">
        Request Id : 100266
      </div>
      <p>Our expert will get in touch with you shortly. You can also get in touch with us on the below
        contact details.</p>
      <ul class="enquiry-actions">
        <li>
          <span class="ak-phone-contact5 action-icon"></span>
          <div class="action-text">
            <p>Call us on</p>
            <h3>022 40743444</h3>
          </div>
        </li>
        <li>
          <span class="ak-clock5 action-icon"></span>
          <div class="action-text">
            <p>Timing</p>
            <h3>10am to 8pm</h3>
          </div>
        </li>
        <li>
          <span class="ak-whatsapp action-icon whatsapp-icon"></span>
          <div class="action-text">
            <h3>WhatsApp</h3>
          </div>
        </li>
      </ul>
    </div>


  </div>
</div>
<!-- Content end -->

<!-- Footer  -->

<!-- Footer end -->
